import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {PitTranslateLoader} from '../services/pit-translate-loader.service';
import {StateProviderService} from '../services/state-provider.service';
import {ERRORS} from '../constants/pages.constants';

@Injectable({
  providedIn: 'root'
})
export class TranslationLoadedGuard implements CanActivate {
  constructor(public router: Router, private pitTranslateLoader: PitTranslateLoader, private stateProviderService: StateProviderService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.pitTranslateLoader.translationLoaded$.pipe(
      map(() => true),
      catchError(() => {
        this.stateProviderService.putParam('error', ERRORS.translationLoadError);
        return of(this.router.createUrlTree(['/error']));
      })
    );
  }
}
